import React, { Component } from "react";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

var setVar = "";
export class Sets extends Component {
  state = {
    set: setVar,
    sets: [{}],
  };

  handleChangeSelect = (event) => {
    setVar = event.target.value;
    this.setState({
      set: event.target.value,
    });
    this.props.handleSelectChange(event.target.value);
  };

  componentDidMount() {
    this.setState({
      set: this.props.sets,
    });
    console.log(this.props.sets);
  }

  render() {
    return (
      <FormControl fullWidth>
        <InputLabel htmlFor="name-simple">Set</InputLabel>
        <Select
          fullWidth
          value={this.state.set}
          onChange={this.handleChangeSelect}
          inputProps={{
            name: "name",
            id: "name-simple",
          }}
        >
          {typeof this.props.sets != "undefined" &&
            this.props.sets.map((se) => (
              <MenuItem value={se.name}>{se.name}</MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  }
}

export default Sets;
